import { createHashRouter } from 'react-router';

import Layout from './components/Layout';
import Home from './pages/Home';
import News from './pages/News';
import NewsDetail from './pages/NewsDetail';
import Events from './pages/Events';
import Download from './pages/Download';
import About from './pages/About';

const router = createHashRouter([
  {
    path: '/',
    Component: Layout,
    children: [
      { index: true, Component: Home },
      { path: 'news', Component: News },
      { path: 'news/:id', Component: NewsDetail },
      { path: 'events', Component: Events },
      { path: 'download', Component: Download },
      { path: 'about', Component: About },
    ],
  },
]);

export default router;
